export class ApiError extends Error {
    name = "ApiError";
    status;
    problem;
    constructor(status, problem) {
        super(problem.detail ?? problem.message ?? problem.title ?? `HTTP ${status}`);
        this.status = status;
        this.problem = problem;
    }
    /** Domain error code if the server provided one. */
    get code() {
        return this.problem.code;
    }
    isUnauthorized() {
        return this.status === 401;
    }
    isForbidden() {
        return this.status === 403;
    }
    isConflict() {
        return this.status === 409;
    }
    isValidation() {
        return this.status === 400 || this.status === 422;
    }
}
export class NetworkError extends Error {
    name = "NetworkError";
    cause;
    constructor(message, cause) {
        super(message);
        this.cause = cause;
    }
}
//# sourceMappingURL=errors.js.map